// getters
const papeleriaEnlistment = state => state.papeleriaEnlistment

export default {
  papeleriaEnlistment
}



// WEBPACK FOOTER //
// ./src/store/modules/papeleria/enlistment/getters.js